// Recensioni reali dalla scheda Google di Alba Immobili.
export const GOOGLE_RATING = 5.0;
export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_7X2GdjDaEJ3vRZeaDQ8geccHRoZWgPJmMqW7WKmFUtyI9cboOz0Zvvfl46eQvMlzOcZi99l4KkuPjbcYgy2OhGj4BnSMSjNOZex8wGOGDZzoqF_Sg%3D%3D&q=Alba+Immobili+Recensioni";

export const REVIEWS = [
  {
    nome: "Alexis Shallah",
    stelle: 5,
    iniziali: "AS",
    testo: "Ho avuto un'ottima esperienza lavorando con Yuri. È stato professionale, sempre pronto a rispondere a qualsiasi domanda e si è assicurato che tutto andasse per il meglio. L'intero processo è stato gestito in modo rapido ed efficiente. Consiglio vivamente Yuri e Alba Immobili a chiunque cerchi un'agenzia affidabile e di fiducia :)",
  },
  {
    nome: "Danila Frattallone",
    stelle: 5,
    iniziali: "DF",
    testo: "Ho trovato Alba Immobili per puro caso e oggi posso dire che è stata una manna dal cielo. Altissimo livello di professionalità, disponibilità e precisione. Ho venduto casa in pochissime settimane al prezzo che speravo. Lascio 5 stelle, troppo poche per dare idea di quello che vale questa agenzia. Consiglio vivamente!",
  },
  {
    nome: "Elettra Currao",
    stelle: 5,
    iniziali: "EC",
    testo: "L'esperienza con Yuri è stata molto positiva. Si è occupato in autonomia dell'organizzazione delle visite all'immobile con costante aggiornamento. Ha inoltre seguito con attenzione tutti gli step per la stipula del contratto dimostrando professionalità e preparazione tecnica. Consigliato!!",
  },
];
